import { FC } from 'react';
import { MinDto } from 'types/other';
import EntityLinkList from './EntityLinkList';

type RelationshipPartnersAndManagersProps = {
    relationshipPartners: MinDto[];
    relationshipManagers: MinDto[];
    /** Opens the employee links in a new browser tab. */
    newTab?: boolean;
};

const RelationshipPartnersAndManagers: FC<RelationshipPartnersAndManagersProps> = ({
    relationshipPartners,
    relationshipManagers,
    newTab,
}) => {
    return (
        <div className="flex flex-col">
            <EntityLinkList domain="employee" items={relationshipPartners} prefix="RP" newTab={newTab} />
            <EntityLinkList domain="employee" items={relationshipManagers} prefix="RM" newTab={newTab} />
        </div>
    );
};

export default RelationshipPartnersAndManagers;
